<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', natureza)">
      <v-card v-if="natureza" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Natureza </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="natureza.descricao"
                    label="Descrição"
                    required
                    counter="255"
                    :rules="[obrigatorio, maximoDigitos(255)]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="natureza.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="natureza.tipoMovimento"
                    :items="['ENTRADA', 'SAIDA']"
                    :rules="[obrigatorio]"
                    label="Tipo Movimento"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(natureza)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Natureza from '../../models/natureza'
import NaturezaService from '../../services/natureza/natureza'
import { obrigatorio, maximoDigitos } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'naturezaParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    natureza: new Natureza(),
    obrigatorio: obrigatorio,
    maximoDigitos: maximoDigitos,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    menuDataInicio: false,
    menuDataFim: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    naturezaParam() {
      return this.naturezaParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.natureza = new Natureza()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.natureza = this.naturezaParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const naturezaSalva =
          this.operacao === 'adicionar'
            ? await NaturezaService.create({ ...data })
            : await NaturezaService.update(data.id, data)

        this.$emit('confirmado', naturezaSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
